import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import type { Option } from '@mylighthouse/prism-ember/types/components/prism/combo-select-input';
import { t } from 'ember-intl';

interface Country {
  id: string;
  name: string;
}

interface Item {
  countries?: Country[];
  id?: string;
  name: string;
}

type CustomOption = Option & {
  id?: string;
};

interface SettingsPosCountrySelectSignature {
  Args: {
    item: Item;
    onChange: (option: { id?: string; name: string }) => void;
  };
}

export default class SettingsPosCountrySelect extends Component<SettingsPosCountrySelectSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get options() {
    if (!this.args.item.countries) {
      return [];
    }

    return this.args.item.countries.map(
      (country) =>
        ({
          id: country.id,
          label: country.name,
          iconFlag: country.id,
        }) as CustomOption,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get value() {
    if (!this.args.item.id) {
      return null;
    }

    return {
      id: this.args.item.id,
      label: this.args.item.name,
      iconFlag: this.args.item.id,
    } as CustomOption;
  }

  @action handleChange(option: CustomOption | CustomOption[]): void {
    const castedOption = option as NonNullable<CustomOption>;
    this.args.onChange({ id: castedOption.id, name: castedOption.label });
  }

  <template>
    <PrismComboSelectInput
      @isSearchable={{true}}
      @onChange={{this.handleChange}}
      @options={{this.options}}
      @placeholder={{t "events.select_countries"}}
      @value={{this.value}}
    />
  </template>
}
